export default __webpack_public_path__ + "static/923-0200945ce2a3648c02033d1914de238f.gif";